import React from 'react';

const ErrorMessage = () => {
    return <div>Error Sending Email</div>
}

export default ErrorMessage